import React, { useEffect, useRef, useState } from "react";
import {
  allColumns,
  itemsInputField as inputFieldsInit,
} from "./HistoryTraining.config";
import { useAppDispatch, useAppSelector } from "../../../../../redux/hooks";
import {
  searchEmployeeAPI, searchTraning,
} from "../../../../../redux/reducer/employee";
import { ColumnProps } from "../../../../../types/models";
import Notification from "../../../../../components/common/notification/notification";
import {
  ColumnPopoverDisplay,
  ExpandSearch,
  InputFields,
  ListActionButton,
  Search,
} from "../../../../../components/common";
import { Button, Col, Form, Popover, Row, Space, Table, Typography } from "antd";
import Icons from "../../../../../assets/icons";
import { ExcelSVG } from "../../../../../assets";
import ModalCustom from "../../../../../components/common/ModalCustom/ModalCustom";
import axiosClient from "../../../../../api/axiosClient";
import { employeeService } from "api";
import {
  generateFileName,
  saveTableOptions,
  getTableOptions,
  formatDateToString,
} from "../../../../../helper/common";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { RangePickerProps } from "antd/es/date-picker";
import { FORMAT_TIME } from "types/enums";
const HistoryTraining = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState<any[]>([]);
  const [params, setParams] = useState<any>({
    page: 1,
    limit: 10,
  });
  const [form] = Form.useForm();
  const [fields, setFields] = useState<any[]>(inputFieldsInit);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  let savedTableOption = getTableOptions(
    "HISTORY_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumns.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumns;
  const [columns, setColumns] = useState<any>(
    defaultColumns.filter((e) => e.show == true)
  );
  columns.find((e)=> e.dataIndex === "index").render=(text,record,index) =>{
    const rowNumber =(currentPage - 1) * params.limit + index + 1;
    return rowNumber;
  }
  const [paramss, setParamss] = useState<any>({});
  const employees = useAppSelector((state) => state.employeesReducer);
  const modalRef = useRef<any>();
  const [type, setType] = useState("");
  const [record, setRecord] = useState(null);
  const dispatch = useAppDispatch();
  const expandRef = useRef<any>();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [fieldStates, setFieldStates] = useState(inputFieldsInit);
  const onClickSearch = async () => {
    setCurrentPage(1);
    var searchFields = expandRef?.current?.getData();
    setParams({ ...params, ...searchFields, page: 1 }); // Đặt trang về 1 khi thực hiện tìm kiếm
    // const formValue = expandRef?.current?.getData();
    // const searchFields = {
    //   ...formValue,
    //   thoiGianDaoTaoCuaKhoaDaoTao: formatDateToString(formValue.thoiGianDaoTaoCuaKhoaDaoTao,FORMAT_TIME.timeDetail),
    //   thoiGianDaoTaoDenCuaKhoaDaoTao: formatDateToString(formValue.thoiGianDaoTaoDenCuaKhoaDaoTao,FORMAT_TIME.timeDetail),
    // //  end: formatDateToString(formValue.end, FORMAT_TIME.dayFull),
    // };
    // setParams({...formValue, ...searchFields,page: 1});
  };
  const getList = async () => {
    setLoading(true);
    try {
      const response = await employeeService.getListHistoryTraining({...params,...form.getFieldsValue()});
      setData(response);
      setLoading(false);
    } catch (error) {
      Notification(
        "error",
        "Đã có lỗi xảy ra khi load danh sách lịch sử đào tạo"
      );
      setLoading(false);
    }
  };
  useEffect(() => {
    dispatch(searchEmployeeAPI({
      page: 1,
      limit: 100,
    }));
    dispatch(searchTraning({
      page: 1,
      limit: 100,
    }));
    }, []);
    useEffect(() => {
      setOptionsKLFields(employees.employeesList, "maNhanVien");
      setOptionsDTFields(employees.TraningList, "tenKhoaDao");
    }, [employees.employeesList,employees.TraningList]); 
    const setOptionsKLFields = (list, hoTen) => {
      if (fieldStates.find((field) => field.name === hoTen)) {
        fieldStates.find((field) => field.name === hoTen).options =
          list?.map((item) => ({
            value: item.maNhanVien,
            label: item.hoTen,
          }));
          setFieldStates([...fieldStates]);
      }
    };
    const setOptionsDTFields = (list, tenKhoa) => {
      if (fieldStates.find((field) => field.name === tenKhoa)) {
        fieldStates.find((field) => field.name === tenKhoa).options =
          list?.map((item) => ({
            value: item.maDaoTao,
            label: item.tenKhoaDaoTao,
          }));
          setFieldStates([...fieldStates]);
      }
    };
  useEffect(() => {
    const disabledDateStart: RangePickerProps["disabledDate"] = currentDate => {
      const endDay =form.getFieldValue("thoiGianDaoTaoDenCuaKhoaDaoTao");
      if (endDay) {
        return currentDate > endDay;
      }
    };
    const disabledDateEnd: RangePickerProps["disabledDate"] = currentDate => {
      const start = form.getFieldValue("thoiGianDaoTaoCuaKhoaDaoTao");
      if (start) {
        return currentDate < start;
      }
    };
    inputFieldsInit.find(e => e.name == "thoiGianDaoTaoCuaKhoaDaoTao").disabledDate = disabledDateStart;
    inputFieldsInit.find(e => e.name == "thoiGianDaoTaoDenCuaKhoaDaoTao").disabledDate = disabledDateEnd;
    setFields([...inputFieldsInit]);
  }, []);
  useEffect(() => {
    getList();
  }, [params]);
  const setShowColumns = (showColumns: React.SetStateAction<ColumnProps[]>) => {
    setColumns(showColumns);
  };
  const setShowColumnsList = (showColumns) => {
    saveTableOptions(
      "HISTORY_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };
  const onChangePagination = (currentPage, pageSize) => {
    setCurrentPage(currentPage);
    setParams({ ...params, page: currentPage, limit: pageSize });
  };
  const onClickExport = async () => {
    var searchFields = expandRef?.current?.getData();
    setParamss({ ...paramss, ...searchFields });
   // handleExportExcel(params);
  };
  useEffect(() => {
    columns.map((index) => {
      // if (index.dataIndex === "ketQuaDaoTao") {
      //   index.render = (v, r, i) => {
      //     const backgroundColors = {
      //       "Đang đào tạo": "#3380FF",
      //       "Đang lên kế hoạch": "#00b335",
      //       "Đã kết thúc": "#f00c0c",
      //     };
      //     const backgroundColor = backgroundColors[v] || "";
      //     return (
      //       <div className="color-column" style={{ backgroundColor }}>
      //       {v}
      //       </div>
      //     );
      //   };
      // }
      if (index.dataIndex === "daoTaoLienTuc") {
        index.render = (v, r, i) => {
            if (r.daoTaoLienTuc === 1) {
                return "Có";
            } else
            {
              return "Không";
            }
        };
    }
    });
  }, []);
  const handleExportExcel = async () => {
    const url = "hanhchinhnhansu/khoa-dao-tao/lich-su-dao-tao/export-excel";
    const baseName = "danh-sach-lich-xu-khoa-dao-tao";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    console.log("aasdasd",params);
    
    try {
      const response = await axiosClient.post(url, form.getFieldsValue(), {
        responseType: "blob",
      });

      const blob = await response.data;

      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;

      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Error exporting Excel");
    }
  };
//   useEffect(() => {
//     dispatch(
//       getPhongBanAPI({
//         page: 1,
//         limit: 100,
//       })
//     );
//   }, []);
//   useEffect(() => {
//     setOptionsPBFields(employees.phongBanList, "idPhongBan");
//   }, [employees.phongBanList]);
//   const setOptionsPBFields = (list, tenPhongBan) => {
//     if (inputFieldsInit.find((field) => field.name === tenPhongBan)) {
//       inputFieldsInit.find((field) => field.name === tenPhongBan).options =
//         list?.map((item) => ({
//           value: item.id,
//           label: item.tenPhongBan,
//         }));
//     }
//   };
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  // Xác định độ dài của mảng columns
  const numberOfColumns = columns.length;
  return (
    <div className="recruitment-list" onKeyDown={onKeyDown} tabIndex={0}>
      <div className="recruitment-container">
      <div className="container">
          <Form form={form} onKeyDown={onKeyDown} tabIndex={0}>
            <Row gutter={[16, 8]}>
              {fields && <InputFields data={fields} />}
            </Row>
            <Row justify={"end"} style={{marginTop: 8}}>
              <Space>
                <Button
                  type="ghost"
                  className="btn-sub"
                  icon={<Icons.reload rev={0} />}
                  onClick={() => {
                    form.resetFields();
                    onClickSearch();
                  }}
                >
                  Xoá tìm kiếm
                </Button>
                <Button
                  icon={<Icons.search rev={0} />}
                  type="primary"
                  onClick={onClickSearch}
                >
                  Tìm kiếm
                </Button>
              </Space>
            </Row>
          </Form>
        </div>
        <div className="container">
          <Space style={{ width: "100%" }} direction="vertical">
            {/*<Typography.Text strong>Danh sách nhân viên</Typography.Text>*/}
            {/*<Divider type="horizontal" style={{ margin: "0" }} />*/}
            <Row justify={"space-between"} gutter={[16, 8]}>
              <Col>
                <Popover
                  trigger="click"
                  placement="topLeft"
                  content={
                    <ColumnPopoverDisplay
                      setShowColumns={setShowColumns}
                      columns={columns}
                      width={"400px"}
                    ></ColumnPopoverDisplay>
                  }
                >
                  <Button
                    icon={<Icons.bars rev={0} />}
                    className="btn-sub"
                    type="ghost"
                  >
                    Cột hiển thị
                  </Button>
                </Popover>
              </Col>
              <Col>
                <Space style={{ width: "100%" }}>
                  <Button
                    className="custom-btn"
                    type="default"
                    onClick={handleExportExcel}
                    icon={<ExcelSVG />}
                  >
                    <Typography>Xuất báo cáo</Typography>
                  </Button>
                </Space>
              </Col>
            </Row>
            {data && (
              <CustomResizableTable
                // rowSelection={{
                //   type: "radio",
                //   ...rowSelection,
                // }}
                setShowColumns={setShowColumnsList}
                pagination={{
                  position: ["bottomRight"],
                  showSizeChanger: true,
                  total: employees.BHXHTotal,
                  onChange: onChangePagination,
                  current: currentPage,
                }}
                onRow={(record, rowIndex) => {
                  return {
                    // onDoubleClick: e => handleView(record.id),
                  };
                }}
                rowKey={(record) => record.id}
                columns={columns}
                dataSource={data}
                bordered={true}
                loading={loading}
                scroll={{ x: 1200 }}
              />
            )}
          </Space>
        </div>
      </div>
    </div>
  );
};

export default HistoryTraining;
